/** @jsx jsx */

import React, {
  useState,
  useRef,
  useContext,
  useEffect,
  useLayoutEffect,
} from 'react';
import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import getBlockById from 'services/apiHelpers/getBlockById';
import { interactionContext } from './interactionContext';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';
import isIE from 'services/isIE';
import isiOS from 'services/isiOS';
import { useSelector } from 'react-redux';
import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import TopicPanelDefaultIcon from 'assets/PortalAvatar.svg'; // TopicPanelDefaultIcon.png';
import hexToRGB from 'services/hexToRGB';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import pubSub from 'services/pubSub';

const { lGrey0, lPink } = colors;

const iconSize = 60;

// older. for when the panel is in a selected state
//
// ${iconSelected &&
//   `
//     pointer-events: none;
//     box-shadow: 0 0 0 2px ${lPink};
//   `}

const TopicIcon = ({
  topicIcon,
  size = 60,
  isEditing,
  iconSelected,
  setIconSelected,
}) => {
  return (
    <div
      css={css`
        position: absolute;
        display: flex;
        justify-content: center;
        left: 0;
        top: 0;
        width: inherit;
        height: ${size}px;
      `}
    >
      <div
        css={css`
          flex-stretch: 0;
          width: ${size}px;
          height: ${size}px;
          border-radius: 50%;
          background: url('${topicIcon?.url ||
            TopicPanelDefaultIcon}') no-repeat;
          background-size: cover;
          ${isEditing &&
            `
            cursor: pointer;
            &:hover {
              transition: box-shadow 0.15s;
              box-shadow: 0 0 0 2px ${lPink};
            }
            `}
        `}
        onClick={
          isEditing
            ? e => {
                e.stopPropagation();
                setIconSelected(!iconSelected);
              }
            : null
        }
      />
    </div>
  );
};

export default TopicIcon;

{
  /* <img
        src={topicIcon?.url || TopicPanelDefaultIcon}
        css={css`
          flex-stretch: 0;
          width: 60px;
          height: 60px;
          border-radius: 50%;

          ${isEditing &&
            `
            cursor: pointer;
            &:hover {
              transition: box-shadow 0.15s;
              box-shadow: 0 0 0 2px ${lPink};
            }
            `}

          ${iconSelected &&
            `
              pointer-events: none;
              box-shadow: 0 0 0 2px ${lPink};
            `}
        `}
        onClick={
          isEditing
            ? e => {
                e.stopPropagation();
                setIconSelected(!iconSelected);
              }
            : null
        }
      /> */
}
